import type { LineItem } from "@b2bportal/core-types";
import type { Fees } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useHotelPayLaterFees = ({
  feeBreakdown,
  showTotal = false,
}: {
  feeBreakdown: Fees;
  showTotal?: boolean;
}): LineItem[] => {
  const { t, formatFiatCurrency } = useI18nContext();

  const payLaterItems = [] as LineItem[];

  if (feeBreakdown.cityTaxes) {
    payLaterItems.push({
      label: t("apac.priceBreakdown.cityTaxesLabel"),
      value: formatFiatCurrency(feeBreakdown.cityTaxes),
    });
  }
  if (feeBreakdown.hotelFees) {
    payLaterItems.push({
      label: t("apac.priceBreakdown.hotelFeesLabel"),
      value: formatFiatCurrency(feeBreakdown.hotelFees),
    });
  }
  if (feeBreakdown.resortFees) {
    payLaterItems.push({
      label: t("apac.priceBreakdown.resortFeesLabel"),
      value: formatFiatCurrency(feeBreakdown.resortFees),
    });
  }
  if (showTotal && feeBreakdown.total) {
    payLaterItems.push({
      label: t("apac.priceBreakdown.dueAtCheckInLabel"),
      value: formatFiatCurrency(feeBreakdown.total),
    });
  }

  return [...payLaterItems];
};
